import loadable from '@loadable/component';

export const SearchVolopsPageLoadable = loadable(
  () => import('./SearchVolopsPage'),
  { resolveComponent: (module) => module.SearchVolopsPage },
);
